/** Mounts the admin app. The font is imported once here for every screen. */
import "@fontsource-variable/instrument-sans/standard.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";

const root = document.getElementById("root");

if (!root) throw new Error("index.html has no #root to mount into");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
